import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/settings").then((module) => ({
    default: module.PlatformSettings,
  })),
);

export const Route = createFileRoute("/admin/settings")({
  component: Page,
});
